import { createRoot } from "react-dom/client";
import { LicenseInfo } from "@mui/x-license-pro";

import { DesktopRouter } from "./react/legacy/DesktopRouter";

/**
 * Installing MUI X license key (version `Pro`)
 * @see https://mui.com/x/introduction/licensing/#how-to-install-the-key
 */
LicenseInfo.setLicenseKey(
  "197a40309f569ece5072b2a350a67cbeTz01NTQ5OSxFPTE3MDE2MTcyMTYzODUsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);

// initialize react
const root = createRoot(getElementByIdOrThrow("react-app"));
root.render(<DesktopRouter />);

function getElementByIdOrThrow(id: string) {
  const result = document.getElementById(id);
  if (!result) {
    throw new Error(`Element #${id} not found`);
  }
  return result;
}
